module.exports = __webpack_public_path__ + "static/media/logo-aspecir.55178f53.png";